// extracted by mini-css-extract-plugin
module.exports = {"Container":"styles_Container__17snM","LogoutLink":"styles_LogoutLink__9tFxR","PendingScreen":"styles_PendingScreen__2PBRc"};